import 'bootstrap/dist/css/bootstrap.min.css';
import 'admin-lte/dist/css/adminlte.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'admin-lte/dist/js/adminlte.min.js';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "./context/AuthContext";
import { initFacebookSDK } from "./context/FacebookInit";


ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="1025992123297-k2lqsf3jtmgr52pv9p8kavlrgsenvkv6.apps.googleusercontent.com">
      <AuthProvider>
        <App />
      </AuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);


initFacebookSDK()
  .then(() => console.log("Facebook SDK listo"))
  .catch(() => console.warn("Facebook SDK no cargado"));

reportWebVitals();
